module.exports = __webpack_public_path__ + "img/playlist-shere-face.b4640aed.svg";